import React from "react";
import { ScrollView } from "react-native";
import styles from '../../Css';

const keyboardAvoidingViewHoc = props => {
    return <ScrollView style={[styles.scrollViewArea, styles.secLightBlueBg]}>{props.children}</ScrollView>;
};

export default keyboardAvoidingViewHoc;
